/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import Box from '@material-ui/core/Box';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import TeamWorkingIllustration from 'svg/illustrations/TeamWorking';

const DEFAULT_VALUE_ITEMS = [
  {
    title: 'Innovación Disruptiva',
    subtitle: 'Experimentamos con formatos y tecnología para romper lo convencional.',
  },
  {
    title: 'Conexión Humana',
    subtitle: 'El talento es el centro; la tecnología es solo el vehículo para potenciarlo.',
  },
  {
    title: 'Aprendizaje Colectivo',
    subtitle: 'Compartimos el conocimiento para que toda la comunidad de TNO Media Lab crezca en conjunto.',
  },
];

const valueIcons = [
  <svg key="zap" width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
  </svg>,
  <svg key="heart" width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path d="m9.653 16.915-.005-.003-.019-.01a20.759 20.759 0 0 1-1.162-.682 22.045 22.045 0 0 1-2.582-1.9C4.045 12.733 2 10.352 2 7.5a4.5 4.5 0 0 1 8-2.828A4.5 4.5 0 0 1 18 7.5c0 2.852-2.044 5.233-3.885 6.82a22.049 22.049 0 0 1-3.744 2.582l-.019.01-.005.003h-.002a.739.739 0 0 1-.69.001l-.002-.001Z" />
  </svg>,
  <svg key="book" width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
  </svg>,
];

const Values = ({ content = {} }) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const valueItems =
    content.items && content.items.length > 0
      ? content.items.map((item, index) => ({
        ...item,
        icon: valueIcons[index % valueIcons.length],
      }))
      : DEFAULT_VALUE_ITEMS.map((item, index) => ({ ...item, icon: valueIcons[index] }));

  return (
    <Box>
      <Grid container spacing={4} direction={isMd ? 'row' : 'column-reverse'}>
        <Grid item xs={12} md={6} data-aos={isMd ? 'fade-right' : 'fade-up'}>
          <Box marginBottom={4}>
            <Typography
              sx={{
                textTransform: 'uppercase',
                fontWeight: 'medium',
              }}
              gutterBottom
              color={'secondary'}
            >
              {content.overline || 'valores'}
            </Typography>
            <Box
              component={Typography}
              sx={{ fontWeight: 700 }}
              variant={'h3'}
              gutterBottom
              align={'left'}
            >
              {content.title || 'Valores del Lab'}
            </Box>
            {!content.hideAdnHeading && (
              <Box
                component={Typography}
                fontWeight={700}
                variant={'h4'}
                gutterBottom
              >
                El ADN{' '}
                <Typography color="primary" variant="inherit" component="span">
                  Unificado
                </Typography>
              </Box>
            )}
            <Typography variant={'h6'} component={'p'} color={'textSecondary'}>
              {content.subtitle ||
                'Tecnología de élite y comunidad de aprendizaje en TNO Media Lab: producción avanzada, networking entre talentos y formación continua.'}
            </Typography>
          </Box>
          <List disablePadding>
            {valueItems.map((item, index) => (
              <ListItem key={index} disableGutters data-aos="fade-up">
                <ListItemAvatar>
                  <Box
                    component={Avatar}
                    variant={'rounded'}
                    color={theme.palette.primary.dark}
                    bgcolor={`${theme.palette.primary.light}22`}
                  >
                    {item.icon}
                  </Box>
                </ListItemAvatar>
                <ListItemText primary={item.title} secondary={item.subtitle} />
              </ListItem>
            ))}
          </List>
        </Grid>
        <Grid
          item
          container
          justifyContent="center"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={isMd ? 'fade-left' : 'fade-up'}
        >
          <Box maxWidth={600} width={'100%'}>
            <TeamWorkingIllustration height={'100%'} width={'100%'} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

Values.propTypes = {
  content: PropTypes.object,
};

export default Values;
